module.exports = __webpack_public_path__ + "static/media/volunteer3.481f988f.svg";